// Simple localStorage-backed comparison cart (max 3 items)
const KEY = "otelpro_compare";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};
const write = (arr) => {
  localStorage.setItem(KEY, JSON.stringify(arr));
  window.dispatchEvent(new Event("compare:update"));
};

export const getCompare = () => read();

export const toggleCompare = (product) => {
  const arr = read();
  const idx = arr.findIndex((p) => p.id === product.id);
  if (idx >= 0) {
    arr.splice(idx, 1);
  } else if (arr.length < 3) {
    arr.push({ id: product.id, slug: product.slug, name: product.name, images: product.images });
  }
  write(arr);
  return read();
};

export const clearCompare = () => write([]);

export const removeFromCompare = (id) => {
  const arr = read().filter((p) => p.id !== id);
  write(arr);
};

export const isInCompare = (id) => read().some((p) => p.id === id);
